module.exports = __webpack_public_path__ + "img/10.518546be.jpg";